import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IInfoPanelButtonProps } from './types';
import {
    getAsidePanelActionsButtonTooltip
} from 'app/view/react_components/aside_panel/asidePanel/helpers/getAsidePanelActionsButtonTooltip';
import { INFO_TITLE } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function InfoPanelButton ({
    tooltip,
    onClick
}: IInfoPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.INFO}
            title={INFO_TITLE}
            tooltip={tooltip && getAsidePanelActionsButtonTooltip({ value: tooltip })}
            onClick={() => {
                setSubTab(EBoardSetting.INFO);
                onClick();
            }}
        />
    );
}
